// =========================
// lib/featureState.js — PLATFORM-003 (runtime read client)
//
// Fetches the current user's runtime feature-visibility map from
// /api/get-feature-state → { flag_key: boolean }. This is the client half of
// the mechanism that replaces build-time REACT_APP_* feature flags: the app
// asks the server "which features are on for me right now" instead of baking the
// answer into the bundle at build time.
//
// Fail-closed: no session, a network error, or a non-OK response all resolve to
// an empty map ({}), so an unresolved feature is treated as OFF (dark).
// =========================

import { supabase } from './supabaseClient';
import { API_BASE_URL } from '../services/api';

export async function fetchFeatureState() {
  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData?.session?.access_token || null;
  if (!token) return { features: {}, error: null };

  try {
    const response = await fetch(`${API_BASE_URL}/get-feature-state`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:  `Bearer ${token}`,
      },
    });
    const body = await response.json();
    if (!response.ok) {
      return { features: {}, error: { message: body?.error || `HTTP ${response.status}` } };
    }
    return { features: body.features || {}, error: null };
  } catch (err) {
    return { features: {}, error: { message: err?.message || 'Network error' } };
  }
}
